import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { functions } from '../functions/_functions';
import { withTheme } from '../core/theming';
import { PropTypesRepo } from '../functions/_propTypes';

import Icon from './Icon';
import Div from './Div';

const HeaderStyled = withTheme(styled.header`
	${(props) => props.pos && functions.makeResponsive('position', props.pos)};
	${(props) => props.w && functions.makeResponsive('width', props.w)};
	${(props) => props.zIndex && functions.makeResponsive('z-index', props.zIndex)};
	${(props) => props.shadow && functions.makeResponsiveShadow(props.shadow, props.theme.shadows)};
	${(props) => props.minH && functions.makeResponsive('min-height', props.minH)};
	${(props) => props.h && functions.makeResponsive('height', props.h)};
	${(props) => props.bg && functions.makeResponsiveProperty(props.bg, 'background', props.theme.colors)};
	${(props) => props.textColor && functions.makeResponsive('color', props.theme.colors[props.textColor])};
`);

HeaderStyled.defaultProps = {
	pos: 'relative',
	w: '100%',
};

const Header = ({ mini, bg, hoverBg, textColor, onToggle, rightChildren, theme, leftChildren }) => (
	<HeaderStyled
		bg={bg}
		textColor={textColor}
		minH={theme.application.headerHeight}
		h={theme.application.headerHeight}
		shadow="4"
	>
		<Div
			m={{ l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth }}
			minW="75px"
			minH={theme.application.headerHeight}
			d="inline-flex"
			justify="center"
			align="center"
			hoverBg={hoverBg}
			cursor="pointer"
			onClick={() => onToggle()}
		>
			<Icon name="Menu" color={textColor} />
		</Div>
		{leftChildren ? (
			<Div
				pos="absolute"
				top="0"
				left="0"
				m={{ l: `calc(75px + ${mini ? theme.application.miniMenuWidth : theme.application.menuWidth})` }}
				minH={theme.application.headerHeight}
				d="inline-flex"
				justify="flex-start"
				align="center"
			>
				{leftChildren}
			</Div>
		) : null}
		{rightChildren ? (
			<Div
				pos="absolute"
				top="0"
				right="0"
				m={{ r: '25px' }}
				minH={theme.application.headerHeight}
				d="inline-flex"
				justify="flex-end"
				align="center"
			>
				{rightChildren}
			</Div>
		) : null}
	</HeaderStyled>
);

Header.propTypes = {
	theme: PropTypes.shape({
		application: {},
	}).isRequired,
	mini: PropTypes.bool,
	bg: PropTypesRepo.bg,
	hoverBg: PropTypesRepo.hoverBg,
	textColor: PropTypesRepo.textColor,
	onToggle: PropTypes.func,
	rightChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	leftChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Header.defaultProps = {
	mini: false,
	bg: 'gray100',
	hoverBg: 'gray400',
	textColor: 'brand500',
	onToggle: () => null,
	rightChildren: null,
	leftChildren: null,
};

export default withTheme(Header);
